module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-menu', {
    staticClass: "el-menu-demo",
    attrs: {
      "theme": "light",
      "default-active": "1",
      "mode": "horizontal"
    }
  }, [_c('el-menu-item', {
    attrs: {
      "index": "1"
    }
  }, [_vm._v("VueCountry")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-77f2295b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Toolbar.vue
// module id = 189
// module chunks = 2